"use strict";

exports.__esModule = true;
exports.TicketCommentsWrapper = exports.TicketComment = exports.StyledText = exports.StyledDateText = exports.CommentsRow = exports.CommentHeadingWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TicketCommentsWrapper = exports.TicketCommentsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__TicketCommentsWrapper",
  componentId: "sc-1kv3gsa-0"
})(["display:flex;overflow:auto;flex-direction:column;opacity:", ";"], function (props) {
  return props.disabled ? "0.2" : "1";
});
var CommentsRow = exports.CommentsRow = _styledComponents["default"].div.withConfig({
  displayName: "styles__CommentsRow",
  componentId: "sc-1kv3gsa-1"
})(["display:flex;flex-direction:column;margin-bottom:0;align-items:flex-start;min-height:90px;overflow:auto;max-height:", ";"], function (props) {
  return props.isFullScreen ? props.isEditing ? "calc(100vh - 180px)" : "calc(100vh - 320px)" : "none";
});
var CommentHeadingWrapper = exports.CommentHeadingWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__CommentHeadingWrapper",
  componentId: "sc-1kv3gsa-2"
})(["display:flex;width:100%;justify-content:space-between;"]);
var TicketComment = exports.TicketComment = _styledComponents["default"].div.withConfig({
  displayName: "styles__TicketComment",
  componentId: "sc-1kv3gsa-3"
})(["position:relative;width:100%;border-bottom:1px solid ", ";padding:0.5rem 0;"], (0, _Theme.val)("LogbookBorderColor"));
var StyledText = exports.StyledText = _styledComponents["default"].span.withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-1kv3gsa-4"
})(["cursor:", ";margin:auto 10px;color:#6558f5;transition:all 0.3s ease;text-decoration:underline;"], function (_ref) {
  var disabled = _ref.disabled,
    muted = _ref.muted;
  return disabled || muted ? "not-allowed" : "pointer";
});
var StyledDateText = exports.StyledDateText = _styledComponents["default"].p.withConfig({
  displayName: "styles__StyledDateText",
  componentId: "sc-1kv3gsa-5"
})(["margin:0;font-size:14px;line-height:1.5;color:#000;display:flex;align-items:center;"]);